var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"company-list"},[_c('v-card',{staticClass:"mx-auto",staticStyle:{"margin-bottom":"50px"},attrs:{"max-width":"785"}},[_vm._v(" Googleログインをして気になる会社を登録してみよう。 ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }